<template>
  <div>
    <filtroProjetosLote
      :sqLote="sqLote"
      @limparGrid="limparGrid"
      @filtroPrjetosLote="filtrarProjetosLote"
    />

    <GridProjetoPorLote
      :importacao="true"
      :items="projetosLote"
      :is-loading="loadingGridLote"
      @projetoPorLoteFiltrados="onPaginarProjetos"
    />
  </div>
</template>

<script>
import { LoteImportacaoService } from "@/services/astec/loteImportacao";
import { paginacaoProjetoPorLoteHelper } from "@/store/helpers/vuex/astec";
import GridProjetoPorLote from "@/components/astec/projetos/gridProjetosPorLote";
import filtroProjetosLote from "@/components/astec/projetos/lotesImportacao/filtroProjetosLote";

export default {
  components: { filtroProjetosLote, GridProjetoPorLote },

  data() {
    return {
      projetosLote: {
        data: [],
        total: 0,
        per_page: 10
      },
      sqLote: null,
      filtrosAtuais: {},
      primeiraCarga: true,
      loadingGridLote: false
    };
  },

  computed: {
    ...paginacaoProjetoPorLoteHelper({
      state: ["currentPage", "pageSize", "total"],
      getters: ["currentPage", "pageSize", "total"],
      actions: []
    }).computed
  },

  async created() {
    const sqAstecIntegracaoLote = localStorage.getItem("sqAstecIntegracaoLote");

    if (sqAstecIntegracaoLote) {
      this.sqLote = parseInt(sqAstecIntegracaoLote);
      this.filtrosAtuais = {
        sq_astec_integracao_lote: this.sqLote,
        page: this.currentPage || 1,
        per_page: this.pageSize || 10
      };
      await this.filtrarProjetosLote();
    }
  },

  methods: {
    ...paginacaoProjetoPorLoteHelper({
      actions: ["setPage", "setPageSize", "setTotal", "resetarPaginacao"]
    }).methods,

    async filtrarProjetosLote(filtro = {}) {
      if (this.loadingGridLote) return;

      this.filtrosAtuais = {
        ...this.filtrosAtuais,
        ...filtro,
        sq_astec_integracao_lote: this.sqLote,
        page: this.currentPage || 1,
        per_page: this.pageSize || 10
      };

      this.loadingGridLote = true;

      try {
        const resultado = await LoteImportacaoService.getProjetosLote(
          this.filtrosAtuais
        );

        this.projetosLote = {
          data: resultado.data || [],
          total: resultado.total ?? 0,
          per_page: resultado.per_page || this.pageSize
        };

        if (typeof resultado.total === "number") {
          this.setTotal(resultado.total);
        }
        if (resultado.per_page && resultado.per_page !== this.pageSize) {
          this.setPageSize(resultado.per_page);
        }

        if (this.$refs.accordionFiltroProjetosLote) {
          this.$refs.accordionFiltroProjetosLote.fechar();
        }
        this.$tools.fecharMenu();
      } catch (error) {
        console.error("Erro ao buscar projetos:", error);
        this.limparGrid();
      } finally {
        this.loadingGridLote = false;
      }
    },

    onPaginarProjetos(novosFiltros) {
      if (novosFiltros.page) this.setPage(novosFiltros.page);
      if (novosFiltros.per_page) this.setPageSize(novosFiltros.per_page);

      this.filtrarProjetosLote({
        ...novosFiltros,
        sq_astec_integracao_lote: this.sqLote
      });
    },

    async limparGrid() {
      this.projetosLote = {
        data: [],
        total: 0,
        per_page: this.pageSize || 10
      };

      this.filtrosAtuais = {
        page: this.currentPage || 1,
        per_page: this.pageSize || 10,
        sq_astec_integracao_lote: this.sqLote
      };
      await this.resetarPaginacao();
    }
  }
};
</script>
